import React, { useContext } from "react";

import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";

import { AppContext } from "./AppContext";
import Branding from "../common/Branding";

import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

// import AnnouncementIcon from "@material-ui/icons/Announcement";
import MailIcon from "@material-ui/icons/Mail";
import CloudIcon from "@material-ui/icons/Cloud";
import HelpIcon from "@material-ui/icons/HelpOutline";
import InfoIcon from "@material-ui/icons/Info";
import DamLogo from "./DamLogo";

export default React.memo(function Menu() {
  const { menuOpen, setMenuOpen, setContentScreen } = useContext(AppContext);
  const handleClick = i => {
    setContentScreen(i);
    setMenuOpen(false);
  };
  return (
    <SwipeableDrawer
      open={menuOpen}
      onOpen={() => setMenuOpen(false)}
      onClose={() => setMenuOpen(false)}
    >
      <Branding theme="light" stacked>
        <DamLogo />
      </Branding>
      <Divider />
      <nav>
        <List>
          <ListItem button onClick={() => handleClick(0)}>
            <ListItemIcon>
              <InfoIcon />
            </ListItemIcon>
            <ListItemText primary="About" />
          </ListItem>
          <ListItem button onClick={() => handleClick(1)}>
            <ListItemIcon>
              <HelpIcon />
            </ListItemIcon>
            <ListItemText primary="Usage" />
          </ListItem>
          <ListItem button onClick={() => handleClick(2)}>
            <ListItemIcon>
              <CloudIcon />
            </ListItemIcon>
            <ListItemText primary="Download data" />
          </ListItem>
          <ListItem button onClick={() => handleClick(3)}>
            <ListItemIcon>
              <MailIcon />
            </ListItemIcon>
            <ListItemText primary="Contact us" />
          </ListItem>
        </List>
      </nav>
    </SwipeableDrawer>
  );
});
